import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-profile-feedback',
  templateUrl: './activity-item-project-profile-feedback.component.html',
  styleUrls: ['./activity-item-project-profile-feedback.component.scss']
})
export class ActivityItemProjectProfileFeedbackComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;
  
  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
